var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5,
    d: "M80 157.5C37.14 157.5 2.5 122.86 2.5 80C2.5 37.14 37.14 2.5 80 2.5C122.86 2.5 157.5 37.14 157.5 80C157.5 122.86 122.86 157.5 80 157.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M121 59.12L121 100.88C121 104.86 117.77 108.09 113.79 108.09L46.21 108.09C42.23 108.09 39 104.86 39 100.88L39 59.12C39 55.14 42.23 51.91 46.21 51.91L113.79 51.91C117.77 51.91 121 55.14 121 59.12ZM47.15 56.71L48.11 57.52L77.14 81.69C78.8 83.07 81.2 83.07 82.86 81.69L111.89 57.52L112.85 56.71L47.15 56.71ZM43.8 95.62L67.46 79.88L43.8 60.18L43.8 95.62ZM116.15 101.36L88.69 83.09L85.93 85.38C84.21 86.81 82.11 87.53 80 87.53C77.89 87.53 75.79 86.81 74.07 85.38L71.31 83.09L43.85 101.36C44.08 102.46 45.05 103.29 46.21 103.29L113.79 103.29C114.95 103.29 115.92 102.46 116.15 101.36ZM116.2 60.18L92.54 79.88L116.2 95.62L116.2 60.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.85c52ee54187ed3c6ca7b64282022f2f.svg";
export { ForwardRef as ReactComponent };